import { ICommonState } from "./common-states.store";
import { GetterTree } from "vuex";
import {
  IGridConfiguration
} from "../../models/common/grid-config.model";
import { COMMON_LOOKUP_TYPE, COMMON_ROUTER_MANAGER, COMMON_MESSAGE_NOTIFICATION } from "../types";

const getters: GetterTree<ICommonState, {}> = <GetterTree<ICommonState, {}>>{
  service: (state: ICommonState) => state.service,
  isPageRendered: (state: ICommonState) => state.isPageRendered,
  isOpenModal: (state: ICommonState) => state.isOpenModal,
  isHorizontalPage: (state: ICommonState) => state.isHorizontalPage,
  navbar: (state: ICommonState) => state.navbar,
  userSession: (state: ICommonState) => state.userSession,
  listOfPlaces: (state: ICommonState) => {
    return state.listOfPlaces;
  },
  previousQuery: (state: ICommonState) => {
    return state.previousQuery;
  },
  listOfPeople: (state: ICommonState) => {
    return state.listOfPeople;
  },
  previousQueryPeople: (state: ICommonState) => {
    return state.previousQueryPeople;
  },
  mapOptions: (state: ICommonState) => {
    return state.mapOptions;
  },
  mapRegions: (state: ICommonState) => {
    return state.mapRegions;
  },
  prevTypeOfPropertyId: (state: ICommonState) => {
    return state.prevTypeOfPropertyId;
  },
  gridConfigsProperties: (state: ICommonState): IGridConfiguration => {
    return state.gridConfigsProperties;
  },
  gridConfigsPersons: (state: ICommonState): IGridConfiguration => {
    return state.gridConfigsPersons;
  },
  gridConfigsDemands: (state: ICommonState): IGridConfiguration => {
    return state.gridConfigsDemands;
  },
  gridConfigsTasks: (state: ICommonState): IGridConfiguration => {
    return state.gridConfigsTasks;
  },
  getLoadingPage: (state: ICommonState): boolean => state.loading || false,
  getStreaming: (state: ICommonState): boolean => state.streaming || false,
  [COMMON_LOOKUP_TYPE.GET_COMMON_VISITED_VIEWS]: (state: ICommonState) => state.visitedViews,
  [COMMON_LOOKUP_TYPE.GET_CONSULTED_NEXT_PERSON]: (state: ICommonState) => state.consultedNextPerson,
  [COMMON_ROUTER_MANAGER.GET_LIST_ROUTER]: (state: ICommonState) => state.routerList,
  [COMMON_ROUTER_MANAGER.GET_LASTEST_ROUTE_LEVEL]: (state: ICommonState) => state.routerList[state.routerList.length - 1],
  [COMMON_MESSAGE_NOTIFICATION.GET_FILTER]: (state: ICommonState) => state.filterMessageNotification,
  [COMMON_MESSAGE_NOTIFICATION.GET_MARK_READ]: (state: ICommonState) => {    
    state.markReadMessageNotificationIds = state.markReadMessageNotificationIds || [];
    return state.markReadMessageNotificationIds;
  },
  sendMessageModalVisible: (state: ICommonState) => state.sendMessageModalVisible,
  printTemplateModalVisible: (state: ICommonState) => state.printTemplateModalVisible,
  printTemplateModalProps: (state: ICommonState) => state.printTemplateModalProps,
  sendMessageModalProps: (state: ICommonState) => state.sendMessageModalProps,
  quickViewObjectProps: (state: ICommonState) => state.quickViewObjectProps,
  notificationMessage: (state: ICommonState) => state.notificationMessage,
  personMergeDataTemp: (state: ICommonState) => state.personMergeDataTemp,
  largeMailingModalVisible: (state: ICommonState) => state.largeMailingModalVisible,
  drawerModels: (state: ICommonState) => state.drawerModels,
  conflictDataInfoVisible: (state: ICommonState) => state.conflictDataInfoVisible,
    userChangeDataFields: (state: ICommonState) => state.userChangeDataFields,
    uploadModels: (state: ICommonState) => state.uploadModels,
};

export default getters;
